import { render } from "./WCLanguagesCollapsibleMenu.vue?vue&type=template&id=36ebc37f&scoped=true"
import script from "./WCLanguagesCollapsibleMenu.vue?vue&type=script&lang=js"
export * from "./WCLanguagesCollapsibleMenu.vue?vue&type=script&lang=js"

import "./WCLanguagesCollapsibleMenu.vue?vue&type=style&index=0&id=36ebc37f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ebc37f"]])

export default __exports__